import { useState } from 'react';
import { toast } from 'sonner';
import { academyApi } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Award, Loader2 } from 'lucide-react';

export function CertificateButton() {
  const [loading, setLoading] = useState(false);

  const download = async () => {
    setLoading(true);
    try {
      const res = await academyApi.certificate();
      const url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Vapelarm_kursintyg.pdf';
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch {
      toast.error('Kunde inte skapa intyget');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-4 flex flex-wrap items-center gap-3 rounded-lg bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-200 dark:border-emerald-800 p-4" data-testid="academy-certificate-card">
      <Award className="h-6 w-6 text-emerald-600" />
      <p className="flex-1 font-ibm text-sm text-emerald-900 dark:text-emerald-200">
        Bra jobbat! Du har klarat alla steg och kan ladda ner ditt kursintyg.
      </p>
      <Button onClick={download} disabled={loading} className="bg-emerald-600 hover:bg-emerald-700" data-testid="academy-certificate-btn">
        {loading ? <Loader2 className="h-4 w-4 animate-spin mr-1" /> : <Award className="h-4 w-4 mr-1" />}
        Ladda ner kursintyg
      </Button>
    </div>
  );
}
